export var IconsBrands = {
  Caviar: 'BRAND_CAVIAR',
  DoorDash: 'BRAND_DOORDASH'
};
export var iconsDefaultValues = {
  Brand: IconsBrands.DoorDash,
  shouldAdjustSmallSizesWhitespace: false
};